import React from 'react'
import MasterLayout from 'views/MasterLayout'
import ProgramRouter from './Router'

export default function ProgramLayout(props) {
  return (
    <MasterLayout>
      <ProgramRouter match={props.match}/>
    </MasterLayout>
  )
}

